import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { installChunkErrorReload } from "@thinkwithsophia/techne-ui";

// Deploy survival, part 1: a stale tab whose chunks 404 after a redeploy gets one automatic
// reload; part 2 (the version beacon + banner) lives in App.
installChunkErrorReload();
if ("serviceWorker" in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
